import React, { useState } from "react";
import { Link } from "react-router-dom";
import contactBtn from "../../assets/images/contact.png";

const FAQAccordion = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What Are The Benefits Of Using Prism Blocks?",
      answer:
        "PrismBlocks enhances the security and trustworthiness of blockchain operations for enterprises by providing a customizable security layer that autonomously learns and integrates with the blockchain. This not only helps in mitigating risks but also ensures data integrity and compliance with regulatory standards without jeopardizing the data inside.",
    },
    {
      question: "How Does Prism Blocks Work?",
      answer: "PrismBlocks operates by embedding a security layer directly into the enterprise’s blockchain infrastructure. This layer uses advanced algorithms to continuously learn and adapt to new threats locally, ensuring that all security measures are up-to-date and effective without compromising the speed or functionality of the blockchain.",
    },
    {
      question: "How Much Does Prism Blocks Cost?",
      answer: "The cost of PrismBlocks can vary depending on the specific needs and the scale of the implementation required by the enterprise. We offer customized pricing based on the number of transactions, the complexity of the integration, and the level of support needed. For detailed pricing information, please contact our sales team.",
    },
    {
      question: "How Long Does It Take To Implement Prism Blocks?",
      answer: "The implementation time for PrismBlocks can vary based on the complexity of the blockchain environment and the specific requirements of the enterprise. Typically, it ranges from a few weeks to a few months. Our team works closely with clients to ensure a smooth and efficient implementation process.",
    },
    {
      question: "What Kind Of Support Is Available For Prism Blocks?",
      answer: "We offer comprehensive support for PrismBlocks, including 24/7 technical support, regular updates, and dedicated account management. Our team is available to assist with any questions or issues that may arise, ensuring your blockchain operations run smoothly and securely.",
    },
  ];

  return (
    <div className="bg-black py-16">
      <div className="container">
        <div className="grid xl:grid-cols-4 lg:grid-cols-3 grid-cols-1 gap-10">
          <div className="col-span-1">
            <h2 className="text-start text-[40px] font-normal mb-2 text-gray-200">
              FAQ
            </h2>
            <p className="text-xl font-light text-white mb-5">
              Have more questions? Send us a message!
            </p>
            <Link to={"/contact"} className="mt-4 block">
              <img
                src={contactBtn}
                className="secure-btn relative mt-10"
                alt=""
              />
            </Link>
          </div>
          <div className="bg-transparent xl:col-span-3 lg:col-span-2 col-span-1 rounded-lg shadow-md border border-[#7E7E7E] p-5">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`${
                  index !== faqs.length - 1 ? "border-b border-[#7E7E7E]" : ""
                } ${activeIndex === index ? "bg-transparent" : ""}`}
              >
                <button
                  className="w-full py-5 flex items-center justify-between px-4 text-[#EFEFEF] text-left text-xl font-medium"
                  onClick={() => toggleAccordion(index)}
                >
                  <span>{faq.question}</span>
                  <span className="text-[#EFEFEF] text-2xl">
                    {activeIndex === index ? "-" : "+"}
                  </span>
                </button>
                {activeIndex === index && (
                  <div className="px-4 pb-4 text-gray-300 text-sm">
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQAccordion;
